import { useMapStore } from './map'
import { useRouteDirectionStore } from './routeDirection'

export const stores = {
  map: useMapStore,
  route: useRouteDirectionStore
};